export interface ConfigCatFeatureFlagUserConfig {
  emailAddress?: string;
  roleId?: number;
  organizationId?: number | null;
}

export interface ConfigCatUserProfile {
  identifier: string;
  email: string;
  custom: { role: string; organization: string };
}

/**
 * The single source of truth for how a viewer maps onto a ConfigCat user.
 * Both evaluation paths — configcat-react (Pages) and @configcat/sdk/node
 * (App Router server) — must build their User from this profile, so targeting
 * rules and percentage-rollout bucketing agree across routers.
 */
export function buildConfigCatUserProfile({
  emailAddress = '',
  roleId,
  organizationId,
}: ConfigCatFeatureFlagUserConfig): ConfigCatUserProfile {
  return {
    identifier: emailAddress,
    email: emailAddress,
    custom: {
      role: roleId?.toString() ?? '',
      organization: organizationId?.toString() ?? '',
    },
  };
}
